export const VIRTUAL_SLOT_ID = 2147483647;
export const FAKE_SLOT_ID_PREFIX = 'fake-slot-id:';
export const FAKE_SLOT_ID_ATTRIBUTE = "fake-slot-id";
